module.exports = __webpack_public_path__ + "img/icon-burger-close.cc670047.svg";